import { ActivatedRouteSnapshot, Data } from '@angular/router';

/** Shell chrome flags declared on route `data` (parent + leaf merge). */
export type ShellRouteData = Data & {
  /** When `calculator`, use the in-app chrome (stage nav + panel). */
  shell?: 'calculator';
  /** Show the disclaimer footer. */
  showFooter?: boolean;
};

/** Merge route data from root → leaf (deeper routes win). */
export function mergedRouteData(route: ActivatedRouteSnapshot): ShellRouteData {
  const merged: ShellRouteData = {};
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    Object.assign(merged, current.data);
    current = current.firstChild;
  }
  return merged;
}

export function showsFooter(route: ActivatedRouteSnapshot): boolean {
  return mergedRouteData(route).showFooter === true;
}

export function isCalculatorShell(route: ActivatedRouteSnapshot): boolean {
  return mergedRouteData(route).shell === 'calculator';
}
